// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BlockContent Component Styles */
.block-content {
  width: 100%;
  line-height: 1.6;
}

.block-content-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  color: #6b7280;
  font-style: italic;
}

.block-content-loading .loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Content styling for HTML content */
.block-content h1,
.block-content h2,
.block-content h3,
.block-content h4,
.block-content h5,
.block-content h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
  font-weight: 600;
}

.block-content p {
  margin-bottom: 1em;
}

.block-content p:last-child {
  margin-bottom: 0;
}

.block-content ul,
.block-content ol {
  margin-bottom: 1em;
  padding-left: 1.5em;
}

.block-content li {
  margin-bottom: 0.25em;
}

.block-content a {
  color: #3b82f6;
  text-decoration: underline;
}

.block-content a:hover {
  color: #1d4ed8;
}

.block-content img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

.block-content blockquote {
  margin: 1em 0;
  padding: 0.5em 1em;
  border-left: 4px solid #e5e7eb;
  background-color: #f9fafb;
  font-style: italic;
}

.block-content code {
  background-color: #f3f4f6;
  padding: 0.125em 0.25em;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 0.875em;
}

.block-content pre {
  background-color: #f3f4f6;
  padding: 1em;
  border-radius: 6px;
  overflow-x: auto;
  margin: 1em 0;
}

.block-content pre code {
  background-color: transparent;
  padding: 0;
}

/* Responsive design */
@media (max-width: 768px) {
  .block-content {
    font-size: 14px;
  }
  
  .block-content-loading,
  .block-content-error,
  .block-content-fallback {
    padding: 12px;
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BlockContent.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,qCAAqC;AACrC;;;;;;EAME,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;;;IAGE,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":["/* BlockContent Component Styles */\n.block-content {\n  width: 100%;\n  line-height: 1.6;\n}\n\n.block-content-loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px;\n  color: #6b7280;\n  font-style: italic;\n}\n\n.block-content-loading .loading-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e5e7eb;\n  border-top: 2px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Content styling for HTML content */\n.block-content h1,\n.block-content h2,\n.block-content h3,\n.block-content h4,\n.block-content h5,\n.block-content h6 {\n  margin-top: 0;\n  margin-bottom: 0.5em;\n  font-weight: 600;\n}\n\n.block-content p {\n  margin-bottom: 1em;\n}\n\n.block-content p:last-child {\n  margin-bottom: 0;\n}\n\n.block-content ul,\n.block-content ol {\n  margin-bottom: 1em;\n  padding-left: 1.5em;\n}\n\n.block-content li {\n  margin-bottom: 0.25em;\n}\n\n.block-content a {\n  color: #3b82f6;\n  text-decoration: underline;\n}\n\n.block-content a:hover {\n  color: #1d4ed8;\n}\n\n.block-content img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 4px;\n}\n\n.block-content blockquote {\n  margin: 1em 0;\n  padding: 0.5em 1em;\n  border-left: 4px solid #e5e7eb;\n  background-color: #f9fafb;\n  font-style: italic;\n}\n\n.block-content code {\n  background-color: #f3f4f6;\n  padding: 0.125em 0.25em;\n  border-radius: 3px;\n  font-family: 'Courier New', monospace;\n  font-size: 0.875em;\n}\n\n.block-content pre {\n  background-color: #f3f4f6;\n  padding: 1em;\n  border-radius: 6px;\n  overflow-x: auto;\n  margin: 1em 0;\n}\n\n.block-content pre code {\n  background-color: transparent;\n  padding: 0;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .block-content {\n    font-size: 14px;\n  }\n  \n  .block-content-loading,\n  .block-content-error,\n  .block-content-fallback {\n    padding: 12px;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
